import { Spinner } from "@/components/General/Spinner/spinner.component";

import { useDefaultHook } from "../helpers/useDefault.hook";
import { DeliveryAddressPartial } from "../partials/deliveryAddress";

const DeliveryBusinessAddress = () => {
    const { loading } = useDefaultHook();

    if (loading) {
        return <Spinner />;
    }

    return <DeliveryAddressPartial />;
};

export { DeliveryBusinessAddress };
